import { GeneratedTheme, Theme } from '../../types';

type Props = {
  core: Theme['core'];
  semantic: GeneratedTheme['semantic'];
};

const mapSemanticTheme = ({ semantic }: Props): Theme['semantic'] => semantic;

export default mapSemanticTheme;
